import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { BASE_URL, REMINDER_URL } from './constant/BaseApiUrl';

export default class MyQuoteService {
  getStatistic() {
    return axios.get(`${BASE_URL}${ApiKey.STATISTIC}`);
  }
  getReminders(payload) {
    return axios.post(`${REMINDER_URL}${ApiKey.REMINDER}/list-by-user`, payload);
  }
  addReminder(payload) {
    return axios.post(`${REMINDER_URL}${ApiKey.REMINDER}`, payload);
  }
  updateReminder(payload) {
    return axios.post(`${REMINDER_URL}${ApiKey.REMINDER}`, payload);
  }
  deleteReminder(id) {
    return axios.delete(`${REMINDER_URL}${ApiKey.REMINDER}/${id}`);
  }
  getNote(quoteId) {
    return axios.get(`${BASE_URL}${ApiKey.VIEW_QUOTE}${quoteId}${ApiKey.NOTE}`);
  }
  addNote(quoteId, payload) {
    return axios.post(`${BASE_URL}${ApiKey.VIEW_QUOTE}${quoteId}${ApiKey.NOTE}`, payload);
  }
  getListQuotes(role, payload) {
    return axios.post(`${BASE_URL}${ApiKey.MY_QUOTE}?${role ? 'dept=' + role : ''}`, payload);
  }

  updateNote(quoteId, noteList, isAgent, role) {
    return axios.put(`${BASE_URL}${ApiKey.VIEW_QUOTE}${quoteId}${ApiKey.NOTE}/save-notes-read?isForExternalAgent=${isAgent}${role ? '&dept=' + role : ''}`, noteList);
  }
}
